import { PopStoreExtendedSubscriptionLevel } from '@ps/models/lib/creator-subscription';

import { compareExtendedSubscriptionLevel } from '../configuration/functions/subscription-display';

/**
 * Whether a viewer may open a 1:1 DM with a creator, given the creator's
 * `store.dmMinimumSubscriptionLevel` and the viewer's own extended standing.
 * Mirrors PopshopRN `isPopStoreDMChatPermitted`:
 *
 * - **No threshold set** → subscribers only: the viewer must have *some* level
 *   that is not a bare `FOLLOWER` (strangers and followers are rejected).
 * - **Threshold set** → the viewer must be defined and rank `>=` the threshold.
 *
 * (Upstream additionally honors an `ALL` threshold, which the web
 * `PopStoreExtendedSubscriptionLevel` store field cannot express, so a set
 * threshold always requires at least a defined viewer level.)
 */
export function isDmPermitted(
  requiredMinimumLevel: PopStoreExtendedSubscriptionLevel | undefined,
  viewerLevel: PopStoreExtendedSubscriptionLevel | undefined,
): boolean {
  if (requiredMinimumLevel == null) {
    return (
      viewerLevel != null &&
      viewerLevel !== PopStoreExtendedSubscriptionLevel.FOLLOWER
    );
  }
  if (viewerLevel == null) return false;
  return (
    compareExtendedSubscriptionLevel(viewerLevel, requiredMinimumLevel) >= 0
  );
}
